import React, {Component} from "react";
import {Link} from "react-router-dom";
import {Spinner} from "../Spinner";
import {AddClientModal} from "./AddClientModal";
import {LinkToSection} from "../elements/LinkToSection";
import {LocalStorage} from "../../utils/LocalStorage";
import {FaIcon} from "../FaIcon";
import {Switch} from "../buttons/Swtich";
import { withTranslation } from 'react-i18next';

// Lista de clientes de la AGENCIA — reusa la estética de "Mis clientes" (buscador + toggle de
// inactivos + filas con "Ver detalle →"), sin asignar/desasignar. Muestra TODOS los clientes.
// Mantiene el toggle de estado por fila (gestión de agencia) + "Agregar cliente".
class AgencyClientsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInactive: false,
            clientSearch: ''
        };
    }

    getFilteredClients() {
        if (!this.props.clients) return null;
        const search = (this.state.clientSearch || '').trim().toLowerCase();
        return this.props.clients
            .filter((c) => this.state.showInactive || c.active)
            .filter((c) => !search || (c.name || '').toLowerCase().includes(search))
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    }

    hiddenInactiveCount() {
        if (!this.props.clients || this.state.showInactive) return 0;
        const search = (this.state.clientSearch || '').trim().toLowerCase();
        return this.props.clients.filter((c) => !c.active && (!search || (c.name || '').toLowerCase().includes(search))).length;
    }

    renderRow(client) {
        const { t } = this.props;
        // El estado (activar/desactivar) y el borrado ahora se manejan SOLO desde
        // Cliente → Configuración (zona de estado / zona de peligro). Acá la fila es read-only:
        // nombre + tag "Inactivo" si corresponde + "Ver detalle →".
        return (
            <li key={client.id} className={`my-clients__row ${client.active ? '' : '-inactive'}`}>
                <span className="my-clients__name" title={client.name}>{client.name}</span>
                {!client.active && (
                    <span className="my-clients__status-tag">{t('status.inactive', 'Inactivo')}</span>
                )}
                <Link className="my-clients__detail" to={`/client/${client.id}/`}>
                    <span>{t('user_marketing.view_detail', 'Ver detalle')}</span>
                    <FaIcon iconName="chevron-right"/>
                </Link>
            </li>
        );
    }

    renderList() {
        const { t } = this.props;
        const clients = this.getFilteredClients();

        if (clients === null) {
            return <div className="box-loader"><Spinner color="positive"/></div>;
        }

        const search = (this.state.clientSearch || '').trim();
        const hasInactive = this.props.clients.some((c) => !c.active);
        const hidden = this.hiddenInactiveCount();

        return (
            <div className="my-clients">
                <div className="my-clients__searchbar">
                    <div className="my-clients__search">
                        <FaIcon iconName="search" className="my-clients__search-icon"/>
                        <input
                            type="text"
                            value={this.state.clientSearch}
                            onChange={(e) => this.setState({clientSearch: e.target.value})}
                            placeholder={t('user_marketing.search_placeholder', 'Buscar cliente…')}
                        />
                        {search && (
                            <button type="button" className="my-clients__search-clear" onClick={() => this.setState({clientSearch: ''})} aria-label="Limpiar">
                                <FaIcon iconName="times"/>
                            </button>
                        )}
                    </div>
                    {hasInactive && (
                        <label className="my-clients__inactive-toggle">
                            <Switch
                                name="showInactive"
                                checked={this.state.showInactive}
                                onChange={(e) => this.setState({showInactive: e.target.checked})}
                                style={{margin: 0}}
                            />
                            <span>
                                {t('user_marketing.show_inactive', 'Mostrar inactivos')}
                                {hidden > 0 ? ` (${hidden})` : ''}
                            </span>
                        </label>
                    )}
                </div>

                {clients.length === 0 ? (
                    <div className="my-clients__empty">
                        <FaIcon iconName={search ? 'search' : 'handshake'}/>
                        <p>{search
                            ? t('user_marketing.no_search_results', 'Sin resultados para tu búsqueda.')
                            : t('user_marketing.no_clients', 'No hay clientes para mostrar.')}</p>
                    </div>
                ) : (
                    <ul className="my-clients__list">
                        {clients.map((client) => this.renderRow(client))}
                    </ul>
                )}
            </div>
        );
    }

    renderHeader() {
        const { t } = this.props;
        if (this.props.myClientsMode === true) {
            return <label>{t('agency_client_list.my_clients_help_text')} <LinkToSection url={"/user/" + LocalStorage.fetchUserId() + "/module/marketing"} text={t('agency_client_list.go_edit_client_assignment')} /></label>;
        }

        return (
            <header className="box-header">
                <h2 className="box-title">{t('agency_client_list.clients_title')}</h2>
                <div className="box-header-actions">
                    <AddClientModal showButton={true} onClientAdded={this.props.afterSuccessfulAgencyClientSubmit}/>
                </div>
            </header>
        );
    }

    render() {
        return (
            <div className="section-body-item -wider box">
                {this.renderHeader()}
                {this.renderList()}
            </div>
        );
    }
}

export default withTranslation()(AgencyClientsList);
